import React from 'react';

import { Box, InputLabel, ToggleButton, ToggleButtonGroup } from '@mui/material';

type Props = {
  label: string;
  children: JSX.Element | JSX.Element[];
  value: string;
  onChange: (value: unknown) => void;
  options: { value: string; label: string }[];
};

export default function RadioTabsWrapper({ options, onChange, value, label, children }: Props) {
  return (
    <Box>
      <InputLabel sx={{ mb: 0.5 }}>{label}</InputLabel>
      <Box sx={{ border: '1px solid', borderColor: 'grey.300', borderRadius: 1, p: 1 }}>
        <ToggleButtonGroup
          exclusive
          onChange={(_, value) => onChange(value)}
          value={value}
          fullWidth
          size="small"
          sx={{ mb: 1 }}
        >
          {options.map(({ label, value }) => (
            <ToggleButton key={value} value={value}>
              {label}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        {children}
      </Box>
    </Box>
  );
}
